<template>
    <div class="system-settings">
      <el-tabs v-model="activeTab" type="card">
        <!-- 轮播图设置 -->
        <el-tab-pane label="轮播图设置" name="carousel">
          <el-card class="box-card">
            <div slot="header">
              <span>轮播图管理</span>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="addCarousel"
              >
                添加轮播图
              </el-button>
            </div>
            <el-table :data="carouselList" border style="width: 100%">
              <el-table-column prop="_id" label="ID" width="80"></el-table-column>
              <el-table-column prop="imageUrl" label="图片">
                <template slot-scope="scope">
                  <img :src="imageUrl + scope.row.imageUrl" style="max-height: 100px" />
                </template>
              </el-table-column>
              <el-table-column prop="link" label="跳转链接"></el-table-column>
              <el-table-column prop="sortOrder" label="排序" width="100"></el-table-column>
              <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                  <el-button size="mini" @click="editCarousel(scope.row)">编辑</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="deleteCarousel(scope.row._id)"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
  
          <!-- 添加/编辑轮播图对话框 -->
          <el-dialog
            :title="carouselDialogTitle"
            :visible.sync="carouselDialogVisible"
            :width="dialogWidth"
          >
            <el-form :model="carouselForm" label-width="100px">
              <el-form-item label="图片">
                <el-upload
                  class="avatar-uploader"
                  action="/api/about/about/carousel"
                  :show-file-list="false"
                  :auto-upload="false"
                  :on-change="handleCarouselImageChange"
                  :before-upload="beforeImageUpload"
                >
                  <!-- <img
                    v-if="imageUrl + carouselForm.image"
                    :src="imageUrl + carouselForm.image"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                  <img 
              v-if=" carouselForm.image" 
              :src="isLocalPath( carouselForm.image) ?  carouselForm.image : imageUrl +  carouselForm.image" 
              class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="跳转链接">
                <el-input v-model="carouselForm.link"></el-input>
              </el-form-item>
              <el-form-item label="排序">
                <el-input-number v-model="carouselForm.sort" :min="1"></el-input-number>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="carouselDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="saveCarousel">确 定</el-button>
            </span>
          </el-dialog>
        </el-tab-pane>
  
        <!-- 小程序头像设置 -->
        <el-tab-pane label="小程序头像设置" name="avatar">
          <el-card class="box-card">
            <div slot="header">
              <span>小程序头像</span>
            </div>
            <div class="avatar-setting">
              <el-upload
                class="avatar-uploader"
                action="/api/about/about/avatar"
                :show-file-list="false"
                :auto-upload="false"
                :on-change="handleAvatarChange"
                :before-upload="beforeAvatarUpload"
              >
                <!-- <img v-if="avatarUrl" :src="imageUrl+avatarUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                <img 
              v-if="avatarUrl" 
              :src="isLocalPath(avatarUrl) ? avatarUrl : imageUrl + avatarUrl" 
              class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div class="avatar-tips">
                <p>建议尺寸：200x200像素</p>
                <p>支持格式：JPG、PNG</p>
              </div>
            </div>
            <div class="save-btn">
              <el-button type="primary" @click="saveAvatar">保存设置</el-button>
            </div>
          </el-card>
        </el-tab-pane>
  
        <!-- 关于我们设置 -->
        <el-tab-pane label="关于我们" name="about">
          <el-card class="box-card">
            <div slot="header">
              <span>关于我们内容设置</span>
            </div>
            <div id="editor" style="border: 1px solid #ccc; margin-top: 10px; min-height: 300px;"></div>
            <div class="save-btn">
              <el-button type="primary" @click="saveAboutContent">保存内容</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </div>
  </template>
  
  <script>
  import E from "wangeditor";
  
  export default {
    name: "SystemSettings",
    data() {
      return {
        activeTab: "carousel",
        // 轮播图相关数据
        carouselList: [],
        carouselDialogVisible: false,
        carouselDialogTitle: "添加轮播图",
        carouselForm: {
          id: "",
          image: "",
          link: "",
          sort: 1,
          imageFile: null // 新增：存储文件对象
        },
        // 头像相关数据
        avatarUrl: "",
        avatarFile: null, // 新增：存储文件对象
        // 关于我们相关数据
        aboutContent: "",
        editor: null,
        editorImages: [], // 存储编辑器中的图片文件
        isEditorInitialized: false,
        // 存储完整的关于我们信息
        aboutInfo: null,
        // 响应式相关数据
   screenWidth: window.innerWidth
      };
    },
    mounted() {
      this.fetchData();
      window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
      this.destroyEditor();
       // 移除事件监听
    window.removeEventListener('resize', this.handleResize);
    },
    computed:{
 // 判断是否为桌面设备
 isDesktop() {
      return this.screenWidth >= 1024;
    },
    // 对话框宽度
    dialogWidth() {
      return this.screenWidth < 768 ? '100%' : '35%';
    },
    },
    methods: {
       // 处理窗口大小变化
     handleResize() {
      this.screenWidth = window.innerWidth;
    },
        isLocalPath(url) {
    return url.startsWith('data:') || url.startsWith('blob:');
  },
      // 初始化富文本编辑器
      initEditor() {
        this.destroyEditor();
        
        this.$nextTick(() => {
          this.editor = new E('#editor');
          
          // 自定义上传图片
          this.editor.config.customUploadImg = (resultFiles, insertImgFn) => {
            this.editorImages = [...this.editorImages, ...resultFiles];
            resultFiles.forEach(file => {
              const reader = new FileReader();
              reader.onload = (e) => {
                insertImgFn(e.target.result);
              };
              reader.readAsDataURL(file);
            });
          };
          
          this.editor.config.onchange = (html) => {
            this.aboutContent = html;
          };
          this.editor.create();
          
          if (this.aboutContent) {
            this.editor.txt.html(this.aboutContent);
          }
          
          this.isEditorInitialized = true;
        });
      },
      
      // 销毁编辑器
      destroyEditor() {
        if (this.editor) {
          this.editor.destroy();
          this.editor = null;
        }
        this.isEditorInitialized = false;
      },
      
      // 上传单个图片
      async uploadImage(file) {
      const formData = new FormData();
      formData.append('file', file);
      
      try {
        const response = await this.$http.post('/api/articles/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        if (response.data.code === 200) {
          return response.data.data.url;
        } else {
          throw new Error(response.data.message || '上传失败');
        }
      } catch (error) {
        console.error('上传图片失败:', error);
        this.$message.error('上传图片失败');
        throw error;
      }
    },
      
      // 获取数据
      async fetchData() {
        try {
          const res = await this.$http.get('/api/about/about');
          if (res.data.code === 200) {
            console.log('关于我们信息:', res);
            this.aboutInfo = res.data;
            this.carouselList = res.data.data.carouselChart || [];
            this.avatarUrl = res.data.data.miniProgramAvatar || '';
            this.aboutContent = res.data.data.aboutContent || '';
            
            // 初始化编辑器并设置内容
            this.initEditor();
          }
        } catch (error) {
          this.$message.error('获取数据失败: ' + error.message);
        }
      },
      
      // 轮播图相关方法
      addCarousel() {
        this.carouselDialogTitle = "添加轮播图";
        this.carouselForm = {
          id: "",
          image: "",
          link: "#",
          sort: this.carouselList.length + 1,
          imageFile: null
        };
        this.carouselDialogVisible = true;
      },
      
      editCarousel(row) {
        this.carouselDialogTitle = "编辑轮播图";
        this.carouselForm = { 
          id: row._id,
          image: row.imageUrl,
          link: row.link,
          sort: row.sortOrder,
          imageFile: null
        };
        this.carouselDialogVisible = true;
      },
      
      async deleteCarousel(id) {
        try {
          await this.$confirm("确定删除该轮播图吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
          
          const res = await this.$http.delete(`/api/about/about/carousel/${id}`);
          if (res.data.code === 200) {
            console.log('删除轮播图结果:', res);
            this.carouselList = res.data.data.carouselChart;
            this.$message.success("删除成功");
          }
        } catch (error) {
          if (error !== 'cancel') {
            this.$message.error('删除失败: ' + error.message);
          }
        }
      },
      
      // 轮播图图片选择变化
      handleCarouselImageChange(file, fileList) {
        const isImage = file.raw.type.indexOf("image/") === 0;
        if (!isImage) {
          this.$message.error("上传文件只能是图片格式!");
          return false;
        }
        
        const isLt5M = file.raw.size / 1024 / 1024 < 5;
        if (!isLt5M) {
          this.$message.error("上传图片大小不能超过 5MB!");
          return false;
        }
        
        // 创建预览URL
        this.carouselForm.image = URL.createObjectURL(file.raw);
        // 保存文件对象
        this.carouselForm.imageFile = file.raw;
        return false; // 返回false阻止自动上传
      },
      
      async saveCarousel() {
        if (!this.carouselForm.image) {
          this.$message.warning("请上传轮播图");
          return;
        }
        
        try {
          const formData = new FormData();
          
          // 如果有图片文件
          if (this.carouselForm.imageFile) {
            formData.append('carouselImage', this.carouselForm.imageFile);
          }
          
          formData.append('link', this.carouselForm.link);
          formData.append('sortOrder', this.carouselForm.sort);
          
          let res;
          if (this.carouselForm.id) {
            // 编辑
            res = await this.$http.put(`/api/about/about/carousel/${this.carouselForm.id}`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
          } else {
            // 新增
            res = await this.$http.post('/api/about/about/carousel', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
          }
          
          if (res.data.code === 200) {
            this.carouselList = res.data.data.carouselChart;
            this.carouselDialogVisible = false;
            this.$message.success("保存成功");
            
            // 释放预览URL
            if (this.carouselForm.image && this.carouselForm.image.startsWith('blob:')) {
              URL.revokeObjectURL(this.carouselForm.image);
            }
            this.fetchData();
          }
        } catch (error) {
          this.$message.error('保存失败: ' + error.message);
        }
      },
      
      // 头像选择变化
      handleAvatarChange(file, fileList) {
        const isImage = file.raw.type.indexOf("image/") === 0;
        if (!isImage) {
          this.$message.error("上传文件只能是图片格式!");
          return false;
        }
        
        const isLt2M = file.raw.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 2MB!");
          return false;
        }
        
        // 创建预览URL
        this.avatarUrl = URL.createObjectURL(file.raw);
        // 保存文件对象
        this.avatarFile = file.raw;
        return false; // 返回false阻止自动上传
      },
      
      async saveAvatar() {
        if (!this.avatarUrl) {
          this.$message.warning("请上传头像");
          return;
        }
        
        if (!this.avatarFile) {
          this.$message.warning("请选择新的头像文件");
          return;
        }
        
        try {
          const formData = new FormData();
          formData.append('miniProgramAvatar', this.avatarFile);
          
          const res = await this.$http.post('/api/about/about/avatar', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          
          if (res.data.code === 200) {
            console.log('保存头像结果:', res);
            this.avatarUrl = res.data.data.miniProgramAvatar;
            this.$message.success("头像保存成功");
            
            // 释放预览URL
            if (this.avatarUrl && this.avatarUrl.startsWith('blob:')) {
              URL.revokeObjectURL(this.avatarUrl);
            }
          }
        } catch (error) {
          this.$message.error('保存失败: ' + error.message);
        }
      },
      
      // 关于我们相关方法
      async saveAboutContent() {
        const content = this.editor.txt.html();
        if (!content) {
          this.$message.warning("内容不能为空");
          return;
        }
        
        try {
          this.uploading = true;
          
          // 上传富文本编辑器中的图片并替换URL
          if (this.editorImages.length > 0) {
            const uploadPromises = this.editorImages.map(file => {
              return this.uploadImage(file).then(serverUrl => {
                const tempUrl = URL.createObjectURL(file);
                return { tempUrl, serverUrl };
              });
            });
            
            const results = await Promise.all(uploadPromises);
            
            let finalContent = content;
            results.forEach(({ tempUrl, serverUrl }) => {
              finalContent = finalContent.replace(tempUrl, serverUrl);
            });
            this.aboutContent = finalContent;
          } else {
            this.aboutContent = content;
          }
          
          const res = await this.$http.post('/api/about/about/content', {
            aboutContent: this.aboutContent
          });
          
          if (res.data.code === 200) {
            this.aboutContent = res.data.data.aboutContent;
            this.$message.success("内容保存成功");
            this.editorImages = []; // 清空已上传图片列表
          }
        } catch (error) {
          console.error('保存内容失败:', error);
          this.$message.error('保存失败: ' + error.message);
        } finally {
          this.uploading = false;
        }
      },
      
      // 通用方法
      beforeImageUpload(file) {
        const isImage = file.type.indexOf("image/") === 0;
        const isLt5M = file.size / 1024 / 1024 < 5;
  
        if (!isImage) {
          this.$message.error("上传文件只能是图片格式!");
          return false;
        }
        if (!isLt5M) {
          this.$message.error("上传图片大小不能超过 5MB!");
          return false;
        }
        return true;
      },
      
      beforeAvatarUpload(file) {
        const isImage = file.type.indexOf("image/") === 0;
        const isLt2M = file.size / 1024 / 1024 < 2;
  
        if (!isImage) {
          this.$message.error("上传文件只能是图片格式!");
          return false;
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 2MB!");
          return false;
        }
        return true;
      },
    },
  };
  </script>
  
  <style scoped>
  .system-settings {
    /* padding: 20px; */
  }
  
  .box-card {
    margin-bottom: 20px;
  }
  
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .avatar-setting {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .avatar-tips {
    margin-left: 20px;
    color: #999;
    font-size: 14px;
  }
  
  .save-btn {
    margin-top: 20px;
    text-align: center;
  }
  
  /* 编辑器容器样式 */
  #editor {
    margin-bottom: 20px;
  }
  
  /* wangeditor 样式覆盖 */
  .w-e-toolbar {
    background-color: #f5f7fa !important;
    border: 1px solid #dcdfe6 !important;
    border-bottom: none !important;
  }
  
  .w-e-text-container {
    border: 1px solid #dcdfe6 !important;
    min-height: 300px !important;
  }
  </style>